module.exports = __webpack_public_path__ + "static/header_bg-1d887dd06c8c6629b64d65bda6de4c5e.jpg";